// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yfkYT","label":"styles_label__Ay2EK"};